import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auth-manage" }
const _hoisted_2 = { class: "auth-tabs" }
const _hoisted_3 = {
  key: 0,
  class: "auth-section"
}
const _hoisted_4 = { class: "section-card" }
const _hoisted_5 = { class: "create-row" }
const _hoisted_6 = { class: "section-card fill" }
const _hoisted_7 = { class: "section-header" }
const _hoisted_8 = { class: "section-count" }
const _hoisted_9 = { class: "code-list" }
const _hoisted_10 = { class: "code-info" }
const _hoisted_11 = { class: "code-value" }
const _hoisted_12 = { class: "code-time" }
const _hoisted_13 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_14 = {
  key: 0,
  class: "pagination-wrap"
}
const _hoisted_15 = {
  key: 1,
  class: "auth-section"
}
const _hoisted_16 = { class: "section-card fill" }
const _hoisted_17 = { class: "section-header" }
const _hoisted_18 = { class: "section-count" }
const _hoisted_19 = { class: "filter-row" }
const _hoisted_20 = { class: "filter-item" }
const _hoisted_21 = { class: "filter-item" }
const _hoisted_22 = { class: "device-list" }
const _hoisted_23 = { class: "device-main" }
const _hoisted_24 = { class: "device-header" }
const _hoisted_25 = ["title"]
const _hoisted_26 = { class: "device-meta" }
const _hoisted_27 = { class: "meta-row" }
const _hoisted_28 = { class: "meta-value" }
const _hoisted_29 = { class: "meta-row" }
const _hoisted_30 = { class: "meta-value" }
const _hoisted_31 = { class: "meta-row" }
const _hoisted_32 = { class: "meta-value" }
const _hoisted_33 = { class: "device-actions" }
const _hoisted_34 = { class: "device-action-item" }
const _hoisted_35 = { class: "device-action-label" }
const _hoisted_36 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_37 = {
  key: 0,
  class: "pagination-wrap"
}

import { ref, onMounted } from 'vue';
import {
  NInput,
  NButton,
  NSelect,
  NTag,
  NSwitch,
  NPagination,
  NPopconfirm,
  createDiscreteApi,
} from 'naive-ui';
import Tools from '@/ts/Tools';

const codeLimit = 20;

const deviceLimit = 20;

export default /*@__PURE__*/_defineComponent({
  __name: 'AuthManage',
  setup(__props) {

const api = createDiscreteApi(['message']);

// ---- 子标签 ----
const subTab = ref<'codes' | 'devices'>('devices');

// ========== 授权码管理 ==========
const newCode = ref('');
const creating = ref(false);
const codeList = ref<any[]>([]);
const codePage = ref(1);
const codeTotal = ref(0);
const codeTotalPages = ref(1);
async function loadCodeList(page: number = 1) {
  Tools.FetchGetAsync<{
    total: number;
    page: number;
    limit: number;
    total_pages: number;
    list: any[];
  }>('auth/list-codes', { page, limit: codeLimit }).then((resp) => {
    if (resp.CheckIsOk()) {
      codeList.value = resp.Data?.list ?? [];
      codeTotal.value = resp.Data?.total ?? 0;
      codeTotalPages.value = resp.Data?.total_pages ?? 1;
      codePage.value = page;
    }
  });
}

async function handleCreateCode() {
  const code = newCode.value.trim();
  if (!code) {
    Tools.AlertError('授权码不能为空');
    return;
  }
  creating.value = true;
  Tools.FetchAsync('auth/create-code', { code }, 'POST').then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('授权码创建成功');
      newCode.value = '';
      loadCodeList(codePage.value);
    }
    creating.value = false;
  }).catch(() => { creating.value = false; });
}

async function handleDeleteCode(id: number) {
  Tools.FetchGetAsync('auth/delete-code', { id }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('删除成功');
      loadCodeList(codePage.value);
    }
  });
}

// ========== 设备管理 ==========
const deviceList = ref<any[]>([]);
const devicePage = ref(1);
const deviceTotal = ref(0);
const deviceTotalPages = ref(1);
const deviceStatusFilter = ref(-1);
const deviceSort = ref('bind_time');

const statusOptions = [
  { label: '全部', value: -1 },
  { label: '已启用', value: 1 },
  { label: '已禁用', value: 0 },
];

const sortOptions = [
  { label: '绑定时间 ↓', value: 'bind_time' },
  { label: '最后登录 ↓', value: 'last_login' },
  { label: '状态优先', value: 'status' },
];

async function loadDeviceList(page: number = 1) {
  Tools.FetchGetAsync<{
    total: number;
    page: number;
    limit: number;
    total_pages: number;
    list: any[];
  }>('auth/list-devices', {
    page,
    limit: deviceLimit,
    status: deviceStatusFilter.value,
    sort: deviceSort.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      deviceList.value = resp.Data?.list ?? [];
      deviceTotal.value = resp.Data?.total ?? 0;
      deviceTotalPages.value = resp.Data?.total_pages ?? 1;
      devicePage.value = page;
    }
  });
}

async function handleToggleStatus(item: any, enabled: boolean) {
  const newStatus = enabled ? 1 : 0;
  Tools.FetchAsync('auth/set-device-status', { id: item.id, status: newStatus }, 'POST').then((resp) => {
    if (resp.CheckIsOk()) {
      item.status = newStatus;
      Tools.AlertSuccess(enabled ? '设备已启用' : '设备已禁用');
    }
  });
}

async function handleDeleteDevice(id: number) {
  Tools.FetchGetAsync('auth/delete-device', { id }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess('设备已删除');
      loadDeviceList(devicePage.value);
    }
  });
}

// ---- 工具函数 ----
function formatTime(unix: number | null | undefined): string {
  if (!unix) return '-';
  const date = new Date(unix * 1000);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  const h = String(date.getHours()).padStart(2, '0');
  const min = String(date.getMinutes()).padStart(2, '0');
  const s = String(date.getSeconds()).padStart(2, '0');
  return `${y}-${m}-${d} ${h}:${min}:${s}`;
}

function truncateId(id: string): string {
  if (!id) return '-';
  if (id.length <= 12) return id;
  return id.substring(0, 8) + '...' + id.substring(id.length - 4);
}

onMounted(() => {
  loadCodeList();
  loadDeviceList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["auth-tab", { active: subTab.value === 'devices' }]),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (subTab.value = 'devices'))
      }, " 设备管理 ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["auth-tab", { active: subTab.value === 'codes' }]),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (subTab.value = 'codes'))
      }, " 授权码管理 ", 2)
    ]),
    (subTab.value === 'codes')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "section-header" }, [
              _createElementVNode("span", { class: "section-title" }, "创建授权码")
            ], -1)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(NInput), {
                value: newCode.value,
                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((newCode).value = $event)),
                placeholder: "输入授权码（支持任意字符）",
                size: "large",
                onKeyup: _withKeys(handleCreateCode, ["enter"])
              }, null, 8, ["value"]),
              _createVNode(_unref(NButton), {
                type: "primary",
                size: "large",
                onClick: handleCreateCode,
                loading: creating.value
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" 创建 ")
                ])),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _cache[11] || (_cache[11] = _createElementVNode("span", { class: "section-title" }, "未使用授权码", -1)),
              _createElementVNode("span", _hoisted_8, "共 " + _toDisplayString(codeTotal.value) + " 个", 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(codeList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "code-item",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.code), 1),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(formatTime(item.create_time)), 1)
                  ]),
                  _createVNode(_unref(NPopconfirm), {
                    onPositiveClick: ($event: any) => (handleDeleteCode(item.id!))
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NButton), {
                        size: "small",
                        type: "error",
                        quaternary: ""
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createTextVNode("删除")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createTextVNode(" 确定删除授权码 \"" + _toDisplayString(item.code) + "\" 吗？ ", 1)
                    ]),
                    _: 2
                  }, 1032, ["onPositiveClick"])
                ]))
              }), 128)),
              (codeList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无未使用的授权码"))
                : _createCommentVNode("", true)
            ]),
            (codeTotalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_unref(NPagination), {
                    page: codePage.value,
                    "onUpdate:page": [
                      _cache[3] || (_cache[3] = ($event: any) => ((codePage).value = $event)),
                      loadCodeList
                    ],
                    "page-count": codeTotalPages.value,
                    "page-slot": 5,
                    size: "small"
                  }, null, 8, ["page", "page-count"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (subTab.value === 'devices')
      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "section-title" }, "已绑定设备", -1)),
              _createElementVNode("span", _hoisted_18, "共 " + _toDisplayString(deviceTotal.value) + " 台", 1)
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "filter-label" }, "状态", -1)),
                _createVNode(_unref(NSelect), {
                  value: deviceStatusFilter.value,
                  "onUpdate:value": [
                    _cache[4] || (_cache[4] = ($event: any) => ((deviceStatusFilter).value = $event)),
                    _cache[5] || (_cache[5] = ($event: any) => (loadDeviceList(1)))
                  ],
                  options: statusOptions,
                  size: "small",
                  style: {"width":"100px"}
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "filter-label" }, "排序", -1)),
                _createVNode(_unref(NSelect), {
                  value: deviceSort.value,
                  "onUpdate:value": [
                    _cache[6] || (_cache[6] = ($event: any) => ((deviceSort).value = $event)),
                    _cache[7] || (_cache[7] = ($event: any) => (loadDeviceList(1)))
                  ],
                  options: sortOptions,
                  size: "small",
                  style: {"width":"140px"}
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "device-item",
                  key: item.id
                }, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("span", {
                        class: "device-id",
                        title: item.device_id
                      }, _toDisplayString(truncateId(item.device_id)), 9, _hoisted_25),
                      _createVNode(_unref(NTag), {
                        type: item.status === 1 ? 'success' : 'error',
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.status === 1 ? '已启用' : '已禁用'), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "meta-label" }, "授权码", -1)),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(item.auth_code), 1)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "meta-label" }, "绑定时间", -1)),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(formatTime(item.bind_time)), 1)
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _cache[18] || (_cache[18] = _createElementVNode("span", { class: "meta-label" }, "最后登录", -1)),
                        _createElementVNode("span", _hoisted_32, _toDisplayString(formatTime(item.last_login_time)), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, _toDisplayString(item.status === 1 ? '已启用' : '已禁用'), 1),
                      _createVNode(_unref(NSwitch), {
                        value: item.status === 1,
                        "onUpdate:value": (val) => handleToggleStatus(item, val)
                      }, null, 8, ["value", "onUpdate:value"])
                    ])
                  ]),
                  _createVNode(_unref(NPopconfirm), {
                    onPositiveClick: ($event: any) => (handleDeleteDevice(item.id!))
                  }, {
                    trigger: _withCtx(() => [
                      _createVNode(_unref(NButton), {
                        class: "device-delete-btn",
                        size: "tiny",
                        quaternary: "",
                        type: "error"
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode("删除")
                        ])),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _cache[20] || (_cache[20] = _createTextVNode(" 确定删除该设备吗？ ")),
                      _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                      _cache[22] || (_cache[22] = _createTextVNode(" 删除后该设备将无法使用插件。 "))
                    ]),
                    _: 2
                  }, 1032, ["onPositiveClick"])
                ]))
              }), 128)),
              (deviceList.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, "暂无绑定设备"))
                : _createCommentVNode("", true)
            ]),
            (deviceTotalPages.value > 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                  _createVNode(_unref(NPagination), {
                    page: devicePage.value,
                    "onUpdate:page": [
                      _cache[8] || (_cache[8] = ($event: any) => ((devicePage).value = $event)),
                      loadDeviceList
                    ],
                    "page-count": deviceTotalPages.value,
                    "page-slot": 5,
                    size: "small"
                  }, null, 8, ["page", "page-count"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})